import { useMemo } from 'react';
import DineinMenuTables from './DineinMenuTables';

export default function DineinMenu({ floorsData, currentOrder, selectTable }) {
  // const [tables, setTables] = useState([]);
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   getAllDineinObjects();
  //   // eslint-disable-next-line
  // }, [showAccordion]);

  // const getAllDineinObjects = async () => {
  //   if (!showAccordion) return;
  //   try {
  //     setLoading(true);
  //     const response = await fetch(
  //       `${API_URL}stores/v1/dineInObjectStatuses?filter.storeId=${storeId}`
  //     );
  //     const { data: { dineInObjectStatuses = [] } = {} } =
  //       await response.json();

  //     // using reduce to not do two for loop (eg filter and then map);
  //     const nonOccupiedDineInObjectIds = dineInObjectStatuses.reduce(
  //       (filteredIdsArr, item) =>
  //         !item.isOccupied
  //           ? filteredIdsArr.concat(item.dineInObjectId)
  //           : filteredIdsArr,
  //       []
  //     );

  //     const filteredFloorData = Object.values(floorsData).reduce(
  //       (filteredFloors, floor) => {
  //         // filter only those tables which are included in nonOccupiedDineInObjectIds array
  //         const tables = (floor.tables ?? []).filter((table) =>
  //           nonOccupiedDineInObjectIds.includes(table.id)
  //         );

  //         // filter only those floors where number of unoccupiced tables are more than 0
  //         if (tables.length > 0) {
  //           return filteredFloors.concat({
  //             ...floor,
  //             tables,
  //           });
  //         }
  //         return filteredFloors;
  //       },
  //       []
  //     );
  //     setTables(filteredFloorData);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const tables = useMemo(() => {
    return Object.values(floorsData ?? {});
  }, [floorsData]);
  return (
    <ul className='tablesAccordionWrap__table'>
      {tables.map(({ name, tables }, index) => {
        return (
          <DineinMenuTables
            key={index}
            name={name}
            tables={tables}
            currentOrder={currentOrder}
            selectTable={selectTable}
          />
        );
      })}
    </ul>
  );
}
